import { stateOptions } from '../commonStateTaxData';

const wageOptions = [
  { codeValue: '0', shortName: '$0 - $10,000' },
  { codeValue: '1', shortName: '$10,001 - $20,000' },
  { codeValue: '2', shortName: '$20,001 - $30,000' },
  { codeValue: '3', shortName: '$30,001 - $40,000' },
  { codeValue: '4', shortName: '$40,001 - $50,000' },
  { codeValue: '5', shortName: '$50,001 - $60,000' },
  { codeValue: '6', shortName: '$60,001 - $70,000' },
  { codeValue: '7', shortName: '$70,001 - $80,000' },
  { codeValue: '8', shortName: '$80,001 - $90,000' },
  { codeValue: '9', shortName: 'Over $90,000' },
];

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Filing status',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married_or_civil_union_couple_joint',
        shortName: 'Married/civil union couple joint',
      },
      {
        codeValue: 'married_or_civil_union_partner_separate',
        shortName: 'Married/civil union partner separate',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Head of household',
      },
      {
        codeValue: 'qualifying_widow_or_widower_or_surviving_civil_union_partner',
        shortName: 'Qualifying widow(er)/surviving civil union partner',
      },
    ],
  },
];

export const wageQuestions = [
  {
    id: 'wages_amount_level',
    title: 'What is the amount of your wages?',
    is_required: true,
    question_type: 'dropdown',
    options: wageOptions,
  },
  {
    id: 'total_other_wages_amount_level',
    title: "What is the amount of the total for all other wages (including your spouse's/civil union partner’s wages)?",
    is_required: true,
    question_type: 'dropdown',
    options: wageOptions,
  },
];

export const allowancesQuestions = [
  {
    id: 'total_exemptions',
    title: 'Enter the number of allowances you are claiming. Entering a number on this line will decrease the amount of withholding and could result in an underpayment on your return.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_withholding_amount',
    title: 'Enter the amount of additional withholdings you want deducted from each pay.',
    question_type: 'short_text',
    placeholder: '$',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];
